<!-- Start Page Title Area -->
<div class="page-title-area page-title-bg1">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>FAQ</h2>
                    <ul>
                        <li><a routerLink="/" itemprop="url" title="EWNS, Custom Ecommerce Platform to meet all your digital needs">Home</a></li>
                        <li>FAQ</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="shape-img2"><img src="assets/img/shape/shape2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/shape3.svg" alt="image"></div>
    <div class="shape-img4"><img src="assets/img/shape/shape4.png" alt="image"></div>
    <div class="shape-img5"><img src="assets/img/shape/shape5.png" alt="image"></div>
    <div class="shape-img7"><img src="assets/img/shape/shape7.png" alt="image"></div>
    <div class="shape-img8"><img src="assets/img/shape/shape8.png" alt="image"></div>
    <div class="shape-img9"><img src="assets/img/shape/shape9.png" alt="image"></div>
    <div class="shape-img10"><img src="assets/img/shape/shape10.png" alt="image"></div>
</div>
<!-- End Page Title Area -->

<!-- Start FAQ Area -->
<section class="faq-area ptb-100">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">About Our Services</span>
            <h2>Frequently Asked Questions</h2>
        </div>

        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="faq-accordion">
                    <ul class="accordion">
                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                 Will SEO work for any websites powered by EWNS platform?
                            </a>
                            <p class="accordion-content">Yes, all our websites have already been optimized for hyper local SEO which works well on all major search engines. However the key to this is the content as they say, "Content is the King". We also offer content curation as one of our services in order to make sure, website gets boost it needs.</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                Are the websites secured?
                            </a>
                            <p class="accordion-content">All the websites in our platform are SSL enabled to keep all the communication between your potential customers and yourself is always secured. All the transactions supported by our platform are also completely secured.</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                What if I have stores in multiple locations?
                            </a>
                            <p class="accordion-content">Using our platform one can easily manage stores in multiple locations with centralised login and individual store owner can also manage their own store front  as well.</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                Will your solution work outside of India as well?
                            </a>
                            <p class="accordion-content">Our platform is agnostic of locale & region. To answer the question, yes, it would work seamlessly. But we would obiously have to spend time on localisation of content with help of our content team.</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                Does your solution have native integration with popular social media channels?
                            </a>
                            <p class="accordion-content">Yes, you can push products, services and latest updates from our portal to multiple popular social media channels.</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                How To Get Start With Us?
                            </a>
                            <p class="accordion-content">If you are an individual business owner, you can register your business <a href="https://portal.ewns.in/signup" title="Register">here.</a> If you are partner, please drop in your contact details from contact section, some one from our team will reach out to you soon.</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                Why Choose Our Services In Your Business?
                            </a>
                            <p class="accordion-content">If you want to take your business digital & global and are looking for a single platform which is easy to use to setup and manage your websites, products, services and latest offers from your store, we believe we are the best in the business out there to help you acheive this. Prompt customer support and good customer experience is at the heart of our services.</p>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="faq-accordion">
                    <ul class="accordion">
                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                Which verticals do you support?
                            </a>
                            <p class="accordion-content">We support all kinds of businesses, if you own a dental clinic or boutique or may be manufacturing specific industry products, we got all of it covered.</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                Do you have a mobile app?
                            </a>
                            <p class="accordion-content">Not as of now, but this is something that we are already working on and we will provide an app to create and manage your webstore from your mobile soon.</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                How many products can I upload?
                            </a>
                            <p class="accordion-content">Unlike some of our competitors, we do not restrict you in terms of number of products. Our pricing is based on the features available for you and not by the quantity of products/services.</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                Can I get personalised website to give a boost to my branding?
                            </a>
                            <p class="accordion-content">Absolutely yes, that's what we are here for, to help any business to acheive their digital goals. We provide all the services which will help your website to acheive your goals.</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                Do you also provide content creation as service?
                            </a>
                            <p class="accordion-content">Yes, our content team does provide their services to our customers to help them update their website and provide insightful content about various products and services. On the other hand, we also believe nobody understand how to pitch your products better than you, hence our team works with you and your team closely to write content to meet your needs.</p>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)">
                                <i class="fas fa-plus"></i>
                                I feel the themes that are there by default won't suit my requirement, Can I get customized one?
                            </a>
                            <p class="accordion-content">For sure, we do support customized theme for every customer, it might come at an extra cost if you are on Basic plan, but we do support this.</p>
                        </li>

                        
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End FAQ Area -->

<!-- Start FAQ Contact Area -->
<section class="faq-contact-area ptb-100 pt-0">
    <div class="container">
        <div class="section-title">
            
            <h2>Any other questions?</h2>
            <span class="sub-title">Contact Us</span>
        </div>

        <div class="row align-items-center">
           

            <div class="col-lg-12 col-md-8">
                <div class="faq-contact-form">
                    <form [formGroup]="contactForm" (ngSubmit)="contact()">
                        <div class="row">
                            <div class="col-lg-6 col-md-12">
                                <div class="form-group">
                                    <input formControlName="name" type="text" class="form-control" placeholder="Name">
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <div class="form-group">
                                    <input formControlName="email" type="email" class="form-control" placeholder="Email">
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <div class="form-group">
                                    <input formControlName="telephone" type="text" class="form-control" placeholder="Phone">
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <div class="form-group">
                                    <input type="text" name="msg_subject" formControlName="subject" class="form-control" placeholder="Subject">
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <textarea name="message" class="form-control" formControlName="message" cols="30" rows="5" placeholder="Your Message"></textarea>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <button type="submit" class="default-btn">Send Message <span></span></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End FAQ Contact Area -->